<template>
  <div>
    <div id="footer">
      <div class="container">
        <div class="row">
          <div class="col-md-7 col-sm-12">
            <ul id="dbdh" class="nav nav-pills">
              <li v-for="(item,index) in navList" :key="index">
                <router-link  :to='item.path'>{{ item.title }}</router-link>
              </li>
            </ul>
            <div class="footer_yqlj">
              <div class="footer_yqlj_h3">
                友情链接：
              </div>
              <ul class="nav nav-pills">
                <li v-for="(v,i) in systemSet.moreNotifyObject"><a :href="v.url" target="_blank">{{ v.title }}</a></li>
              </ul>
            </div>
          </div>

          <div id="footer_right" class="col-md-5 col-sm-12">
            <div class="footer_right_content">
              <div class="footer_fwrx">全国服务热线<span>（{{ systemSet.web_site_time_slot }}）</span></div>
              <div class="footer_tel">
                <span class="iconfont icon-dianhua1"></span>
                <div class="footer_tels">
                  {{ systemSet.web_site_hotline }}
                </div>
              </div>
              <div class="footer_address">
                地址：{{ systemSet.web_site_address }}
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>

    <div id="copyright">
      <div class="container">
        <div>
          {{ systemSet.web_site_copy }}
        </div>
        <a href="https://beian.miit.gov.cn" target="_blank">{{ systemSet.web_site_icp }}</a>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      navList:[],
      systemSet:[],
      queryInfo:{
        name: '',
        type: 'footer'
      }
    }
  },
  created () {
  this.getNavList()
  },
  mounted () {
    this.utils.systemConfig(1).then(res=>{
      if (res.data.code !== 200) return false
      this.systemSet = res.data.data.content
    });
  },
  methods: {
    async getNavList () {
      const {data: res} = await this.$http.get('home/nav_list', {params: this.queryInfo})
      if (res.code !== 200) return false
      this.navList = res.data.list
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue